var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/collection") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/collection",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#B2B2B2",
    strokeWidth: 1.3,
    fill: "#FFFFFF",
    x: 4.65,
    y: 4.65,
    width: 9.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#B2B2B2",
    strokeWidth: 1.3,
    fill: "#FFFFFF",
    x: 7.15,
    y: 7.15,
    width: 9.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#B2B2B2",
    strokeWidth: 1.3,
    fill: "#FFFFFF",
    x: 9.65,
    y: 9.65,
    width: 9.7,
    height: 9.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.e2b63beab905f859321417bdf8814f36.svg";
export { ForwardRef as ReactComponent };